import cx from 'classnames';

import { IconType } from 'utils/types';

const iconVariants = {
  default: 'stroke-black',
  alert: 'stroke-tertiary-50',
  primary: 'stroke-primary-50',
  warning: 'stroke-warning-50',
  white: 'stroke-white',
};

const backgroundVariants = {
  default: 'bg-gradient-green',
  alert: 'bg-tertiary-50',
  tertiary: 'bg-tertiary-10',
  gray: 'bg-gradient-gray',
  gray10: 'bg-gray-10',
  lightRed: 'bg-alert-10',
  warning: 'bg-warning-10',
  secondary: 'bg-secondary-10',
  primary: 'bg-primary-10',
  noRoomSelected: 'bg-no-room-selected-icon',
};

export type IconVariant = keyof typeof iconVariants;
export type BackgroundVariant = keyof typeof backgroundVariants;

interface GradientIconWithShadowProps {
  icon: IconType;
  iconVariant?: IconVariant;
  bgVariant?: BackgroundVariant;
  className?: string;
  iconClassName?: string;
}

const GradientIconWithShadow = ({
  icon: Icon,
  iconVariant = 'default',
  className,
  bgVariant = 'default',
  iconClassName,
}: GradientIconWithShadowProps) => (
  <div className={cx('shadow-icon bg-gradient-white w-fit rounded-3xl p-2', className)}>
    <div className={cx('rounded-2xl p-4', backgroundVariants[bgVariant])}>
      <Icon className={cx('h-8 w-8 shrink-0 stroke-2', iconVariants[iconVariant], iconClassName)} />
    </div>
  </div>
);

export default GradientIconWithShadow;
